import * as React from "react";
import { SVGProps } from "react";

const ReserveRights = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000" {...props}>
    <path
      fillRule="evenodd"
      d="M1000.05 1999.974c550.8 0 1000-449.2 1000-1000 0-550.7-449.2-1000-1000-1000-550.7 0-1000 449.3-1000 1000-.1 550.8 449.2 1000 1000 1000z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M743.55 481.674h144c5.5 0 9.9 4.5 9.9 10v210.4c0 5.6 4.5 10 10 10h184.9c5.5 0 10-4.4 10-10v-210.4c0-5.5 4.4-10 10-10h143.9c5.5 0 10 4.5 10 10v210.4c0 5.6 4.4 10 10 10h176c5.6 0 10 4.5 10 10v143.6c0 5.6-4.4 10-10 10h-176c-5.6 0-10 4.5-10 10v223.5c0 5.5 4.4 10 10 10h176c5.6 0 10 4.4 10 10v143.6c0 5.5-4.4 10-10 10h-176c-5.6 0-10 4.5-10 10v210.4c0 5.5-4.5 10-10 10h-143.9c-5.6 0-10-4.5-10-10v-210.4c0-5.6-4.5-10-10-10h-184.8c-5.5 0-10 4.5-10 10v210.4c0 5.5-4.4 10-9.9 10h-144c-5.5 0-10-4.5-10-10v-210.4c0-5.6-4.4-10-10-10h-176c-5.6 0-10-4.5-10-10v-143.6c0-5.6 4.4-10 10-10h176c5.6 0 10-4.5 10-10v-223.5c0-5.5-4.4-10-10-10h-176c-5.6 0-10-4.4-10-10v-143.6c0-5.5 4.4-10 10-10h176c5.6 0 10-4.4 10-10v-210.4c-.2-5.5 4.4-10 9.9-10zm358.9 627.6v-223.6c0-5.5-4.5-10-10-10h-184.9c-5.5 0-10 4.5-10 10v223.5c0 5.5 4.5 10 10 10h184.9c5.5.1 10-4.5 10-9.9z"
      clipRule="evenodd"
    />
  </svg>
);

export default ReserveRights;
